/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { throwError } from 'rxjs';
import { ErrorService } from './error.service';

@Injectable({
    providedIn: 'root'
})
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

    // Error handling has to be loaded first.
    // Because of this we should manually inject the services with Injector.
    constructor(
        private injector: Injector
    ) { 
    }

    handleError(error: Error | HttpErrorResponse) {

        const errorService = this.injector.get(ErrorService);
        // TODO: figure out how to show error to end user
        // const notifier = this.injector.get(ErrorDialogService);

        let message = '';
        let stackTrace = '';

        if (error instanceof HttpErrorResponse) {
            // Server Error
            message = errorService.getServerMessage(error);
            stackTrace = errorService.getServerStack(error);
            // notifier.openDialog(message);
        } else {
            // Client Error
            message = errorService.getClientMessage(error);
            stackTrace = errorService.getClientStack(error);
            // notifier.openDialog(message);
        }
        // window.location.reload();
        // window.alert(error.message);
        console.log(message, stackTrace);
        throwError(error);
    }
}
